/**
 * Created by yihong on 1/24/18.
 */


export default {
  wechat: {
    js: 'D66ADE70755B',
    app: '1DF81F20CD7M',
    renew: '2BU45R97JD7A',
  },
  alipay: {
    js: 'CD3402D6DA9F',
    app: 'ZFB34XYB49X6',
    renew: 'QA3R2TD56U12',
  },
  phone: 'F83F895BCD64',
  ios: '1F3X7JPT014M',
  jd: {
    js: 'J3C03EC0249B', // 京东普通包，form提交
    renew: 'JDDUT2018515', // 京东代扣,直接跳链
  },
  ccb: 'C127CA0D4C66', // 建行支付.h5
  cmb: {
    js: 'EF5C7535A51M',
    app: 'SCENE535A51T',
  },
};

